"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _actions = require('web/actions');
var _videoCall = require('web/actions/videoCall');






































const initialState = {
  permsState: _videoCall.permsStates.DENIED,
  isBrowserCompatible: true,

  isOnCall: false,

  isMicOn: true,
  isCamOn: true,
  isScreenSharingOn: false,
  areMicIssuesPresent: false,
  areCamIssuesPresent: false,

  videoInDevices: [],
  audioInDevices: [],
  currentMicDeviceId: '',
  currentCamDeviceId: '',
}

// The return type includes `undefined` because CYCLE_CAM with no video devices
// returns nothing, as the JS reducer did (see the comment there).
exports. default = (
  state = initialState,
  anyAction,
) => {
  // SAFETY: the root reducer hands every action to every slice. The union
  // only describes the types handled below; anything else falls through to
  // `return state` without reading its payload.
  const action = anyAction 
  switch (action.type) {
    case _actions.types.SET_PERMS_STATE:
      return { ...state, permsState: action.payload.state }
    case _actions.types.SET_BROWSER_COMPATIBILITY:
      return { ...state, isBrowserCompatible: action.payload.isCompatible }
    case _actions.types.SET_MIC_STATUS:
      return { ...state, isMicOn: action.payload.isOn }
    case _actions.types.SET_CAM_STATUS:
      return { ...state, isCamOn: action.payload.isOn }
    case _actions.types.SET_SCREEN_SHARING_STATUS:
      return { ...state, isScreenSharingOn: action.payload.isOn }
    case _actions.types.SET_DEVICES_LIST: {
      const { payload } = action
      const currentMicDeviceId = state.currentMicDeviceId ||
        payload.audioIn[0] && payload.audioIn[0].deviceId
      const currentCamDeviceId = state.currentCamDeviceId ||
        payload.videoIn[0] && payload.videoIn[0].deviceId

      return {
        ...state,
        audioInDevices: payload.audioIn,
        videoInDevices: payload.videoIn,

        areMicIssuesPresent: payload.audioIn.length ? state.areMicIssuesPresent : true,
        areCamIssuesPresent: payload.videoIn.length ? state.areCamIssuesPresent : true,

        // With no device and no current id these are `undefined`, as in JS.
        currentMicDeviceId: currentMicDeviceId ,
        currentCamDeviceId: currentCamDeviceId ,
      }
    }
    case _actions.types.SET_CURRENT_MIC_DEVICE_ID:
      return { ...state, currentMicDeviceId: action.payload.deviceId }
    case _actions.types.SET_CURRENT_CAM_DEVICE_ID:
      return { ...state, currentCamDeviceId: action.payload.deviceId }
    case _actions.types.TOGGLE_MIC:
      return { ...state, isMicOn: !state.isMicOn }
    case _actions.types.TOGGLE_CAM:
      return { ...state, isCamOn: !state.isCamOn }
    case _actions.types.CYCLE_CAM: {
      const { videoInDevices, currentCamDeviceId } = state
      const isCamCycleAvailable = videoInDevices.length > 0

      // Existing behaviour kept: with no video devices the slice becomes
      // `undefined` (and is re-initialised on the next action). The UI only
      // offers the cycle button when there is more than one camera.
      if (!isCamCycleAvailable) return undefined

      const currentCamIdx = videoInDevices
        .findIndex(x => x.deviceId === currentCamDeviceId)
      const nextCamIdx = (currentCamIdx + 1) % videoInDevices.length

      return {
        ...state,
        currentCamDeviceId: videoInDevices[nextCamIdx].deviceId,
      }
    }
    case _actions.types.SET_MIC_ISSUES_STATE:
      return {
        ...state,
        areMicIssuesPresent: action.payload.areIssuesPresent,
      }
    case _actions.types.SET_CAM_ISSUES_STATE:
      return {
        ...state,
        areCamIssuesPresent: action.payload.areIssuesPresent,
      }

    case _actions.types.SET_IS_ON_CALL:
      return { ...state, isOnCall: action.payload }
  }
  return state
}
